import { enUS, fr } from "date-fns/locale";

export let HOST =
  process.env.NODE_ENV == "production"
    ? "https://api.lancerkit.com"
    : "http://localhost:3000";

export let DATEFNS_LOCALES = { en: enUS, fr };
